import React, { useEffect, useState } from "react";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  signInWithPopup,
  updateProfile,
} from "firebase/auth";

import { createContext } from "react";
import app from "../firebase/firebase.config";

// Create Context api
export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  // Get Auth Config
  const auth = getAuth(app);
  // States
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  // Firebase Functions
  //
  //Create user
  const createUser = (email, pass) => {
    setLoading(true);
    return createUserWithEmailAndPassword(auth, email, pass);
  };

  //   Update User
  const updateUserProfile = (info) => {
    return updateProfile(auth.currentUser, info);
  };

  //Login with Email and Password
  const logIn = (email, pass) => {
    setLoading(true);
    return signInWithEmailAndPassword(auth, email, pass);
  };
  //logout user
  const logOut = () => {
    setLoading(true);
    return signOut(auth);
  };

  //   Google Sign In
  const loginProvider = (provider) => {
    setLoading(true);
    return signInWithPopup(auth, provider);
  };

  //   Auth Observer: onAuthStateChange
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser?.email || currentUser === null) {
        setUser(currentUser);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  // All values should be mentioned here
  const authValues = {
    user,
    loading,
    createUser,
    updateUserProfile,
    logIn,
    logOut,
    loginProvider,
  };

  return (
    <AuthContext.Provider value={authValues}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;
